/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { UpdateBookingAccountProfilePayload } from 'api/actions/update-booking-account-profile/update-booking-account-profile-payload';
import { UpdateBookingAccountProfilePathParameters } from 'api/actions/update-booking-account-profile/update-booking-account-profile-path-parameters';
import { UpdateBookingAccountProfileResponse } from 'api/actions/update-booking-account-profile/update-booking-account-profile-response';

type UpdateBookingAccountProfileQueryParameters = Record<string, any>;

/**
 * The path of the UpdateBookingAccountProfile action.
 */
export const updateBookingAccountProfileActionPath = new SweetPath<keyof UpdateBookingAccountProfilePathParameters>(
  '/reservations/account/profile',
  { path: '{param}' }
);

/**
 * Creates a contextualized UpdateBookingAccountProfile actions.
 */
export default function createUpdateBookingAccountProfileAction(axios: AxiosInstance) {
  return function updateBookingAccountProfileAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: UpdateBookingAccountProfileQueryParameters;
    payload: UpdateBookingAccountProfilePayload;
  }) {
    const path = updateBookingAccountProfileActionPath.original;

    return axios.patch<
      UpdateBookingAccountProfileResponse,
      UpdateBookingAccountProfileResponse,
      UpdateBookingAccountProfilePayload
    >(path, payload);
  };
}
